import { API_ROUTES } from "../apiRoutes";
import { REQUEST_METHODS } from "../configs.apiClient";
import { HttpClient } from "../HttpClient";
import { SignedUrlRes } from "@/types/consumption.types";
import {
  ConsumptionStateCategoryEnum,
  SpecialAccessResponse,
  SpecialAccessWebOfferPageResponse,
} from "@/screens/specialAccess/types/specialAccess.types";

export class SpecialAccessAPIClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async getSpecialAccessSignedUrl({
    episodeId,
    dialect,
    lang,
  }: {
    episodeId: number;
    dialect: string;
    lang: string;
  }) {
    const method = REQUEST_METHODS.GET;
    const endpoint = API_ROUTES.consumption.getSpecialAccessSignedUrl;

    const queryParams = {
      episodeId,
    };

    const response = await this.httpClient.nestRequest<{
      data: SignedUrlRes;
      responseMessage: string;
    }>({
      endpoint,
      options: {
        method,
      },
      queryParams,
      addToken: true,
      lang,
      dialect,
    });

    return response?.data;
  }

  async getSpecialAccessWebOfferPage({
    contentId,
    contentType,
    dialect,
    lang,
  }: {
    contentId: number;
    contentType: string;
    dialect: string;
    lang: string;
  }) {
    const method = REQUEST_METHODS.GET;
    const endpoint = API_ROUTES.consumption.getSpecialAccessWebOfferPage;

    const response =
      await this.httpClient.nestRequest<SpecialAccessWebOfferPageResponse>({
        endpoint,
        options: {
          method,
        },
        queryParams: {
          content_id: contentId,
          content_type: contentType,
        },
        addToken: false,
        lang,
        dialect,
      });

    return response;
  }

  async postSpecialAccessUserState({
    contentId,
    contentType,
    dialect,
    lang,
  }: {
    contentId: number;
    contentType: string;
    dialect: string;
    lang: string;
  }) {
    const method = REQUEST_METHODS.POST;
    const endpoint = API_ROUTES.consumption.specialAccessUserState;

    const response = await this.httpClient.nestRequest<SpecialAccessResponse>({
      endpoint,
      options: {
        method,
      },
      body: {
        content_id: contentId,
        content_type: contentType,
      },
      addToken: true,
      lang,
      dialect,
    });

    return response;
  }

  async getSpecialAccessUserState({
    dialect,
    lang,
  }: {
    dialect: string;
    lang: string;
  }) {
    const method = REQUEST_METHODS.GET;
    const endpoint = API_ROUTES.consumption.specialAccessUserState;

    const response = await this.httpClient.nestRequest<SpecialAccessResponse>({
      endpoint,
      options: {
        method,
      },
      addToken: true,
      lang,
      dialect,
    });

    return response;
  }

  async patchSpecialAccessUserState({
    stateCategory,
    stateValue,
    dialect,
    lang,
  }: {
    stateCategory: ConsumptionStateCategoryEnum;
    stateValue: number;
    dialect: string;
    lang: string;
  }) {
    const method = REQUEST_METHODS.PATCH;
    const endpoint = API_ROUTES.consumption.specialAccessUserState;

    const response = await this.httpClient.nestRequest<SpecialAccessResponse>({
      endpoint,
      options: {
        method,
      },
      body: {
        state_category: stateCategory,
        state_value: stateValue,
      },
      addToken: true,
      lang,
      dialect,
    });

    return response;
  }
}
